<style lang="stylus" scoped>
    .publish-container
        width 520px

        .pc-des
            position relative

            .pc-des-count
                position absolute
                color $text-color-light
                bottom 2px
                right 10px
                line-height normal

        .pc-tag
            display inline-block
            padding 0 5px
            margin-right 10px
            border-radius 12px
            box-shadow $shadow-card
            margin-bottom 10px
            line-height 20px
            max-width 480px
            word-break break-all

            .pct-delete
                width 8px
                height 8px
                stroke #3788e3
                margin-top 7px
                margin-left 5px

                &:hover
                    stroke #de5145

        .pc-tagipt
            position relative

            .pct-suggest
                width 330px
                position absolute
                color $text-color
                top calc(100% + 2px)
                left 0
                z-index 9
                background white
                box-shadow $shadow-base
                border-radius $border-radius-base
                padding 5px 0

                .pcts-item
                    list-style none
                    padding 7px 16px
                    transition all $transition-time $ease-in-out

                    &:hover
                        background $input-disabled-bg


        .pc-clone
            height 32px
            .pcc-price
                width 100px
                height 24px
                vertical-align middle
            .icon-arrow
                position absolute
                right 5px
                top 11px
                color #b1b1b1

            .ivu-form-item
                margin-bottom 0
                width 250px
        .pc-allow
            margin-bottom 0
            margin-top 10px
            &+span
                margin-right 4px

        .pc-hint
            width 400px
            height 24px
            background #ffffff
            border 0.5px solid rgba(0, 0, 0, 0.104759)
            box-shadow 0px 8px 16px rgba(0, 0, 0, 0.0982299), 0px 4px 8px rgba(0, 0, 0, 0.1)
            border-radius 6px

            div
                width 50%
                display flex
                flex-wrap wrap
                justify-content space-around

                p
                    width 100%
                    font-size 22px
                    font-weight lighter
                    text-align center
                    margin-top 20px

                svg
                    width 120px
                    height 120px
                    fill #c1c1c1
                    transition fill 0.15s
                    cursor pointer

            .pch-cancel
                border-right 2px solid #c1c1c1
                padding-right 2px

                svg
                    &:hover
                        fill #de5347

            .pch-update
                svg
                    &:hover
                        fill var(--themeColor)



    .dialog-publish
        padding 16px 0
        line-height 1.5
        font-size 16px
    .published-mask
        modal-mask()
        .published-model
            position absolute
            min-width 270px
            padding 0px 65px
            height 224px
            background #ffffff
            border 0.5px solid rgba(0, 0, 0, 0.104759)
            box-shadow 0px 8px 16px rgba(0, 0, 0, 0.0982299), 0px 4px 8px rgba(0, 0, 0, 0.1)
            border-radius 6px
            .topbar
                position absolute
                width 100%
                left 0
                height 25px
                .item-icon
                    position absolute
                    left 0
                    right 0
                    top -47px
                    margin 0 auto
                    width 130px
                    height 108px
                .item-close
                    position absolute
                    right 14px
                    top 13px
                    width 10px
                    height 10px
                    user-select none
                    cursor pointer
            .text
                margin-top 85px
                text-align center
                font-size 20px
                line-height 23px
                color #4068EB
            .btn-box
                display flex
                justify-content center
                height 36px
                margin 36px auto 0 auto
                .btn
                    min-width 127px
                    white-space nowrap
                    padding 0 15px
                    height 36px
                    border-radius 4px
                    font-size 14px
                    text-align center
                    line-height 36px
                    user-select none
                    cursor pointer
                    transition background-color .2s linear
                .cancel
                    margin-right 15px
                    background-color #D5D7DB
                    &:hover
                        background-color #b5b5b5
                .ok
                    background-color var(--themeColor)
                    color #fff
                    &:hover
                        background-color var(--themeHover)
    .publish-dropdown
        width 28%
        .ivu-select-dropdown
            width unset
        .publish-dropdown-title
            display inline-block
            width 100%
            height 32px
            line-height 1.5
            padding 4px 7px
            font-size 12px
            border 1px solid #dcdee2
            border-radius 4px
            color #515a6e
            background-color #fff
            background-image none
            position: relative;
            transition border .2s ease-in-out,background .2s ease-in-out,box-shadow .2s ease-in-out,-webkit-box-shadow .2s ease-in-out
            &:active,&:hover
                border-color var(--themeHover)
            p
                height 24px
                line-height 24px
                width 100%
                overflow hidden
                text-overflow ellipsis
                white-space nowrap
    .allow-modal
        .ivu-modal-footer
            direction rtl

    .publish-container-v1
        input::-webkit-input-placeholder,textarea::-webkit-input-placeholder
            color rgba(0, 0, 0, 0.5)
        .publish-toptips
            font-size 12px
            color #000
            margin-bottom 20px
        .pc-tag
            background #F5F5F5
            border-radius 2px
            border 1px solid #F5F5F5
            font-size 12px
            .tags-delete
                margin-left 5px
                cursor pointer
        .publish-radiogroup
            .ivu-radio-wrapper
                display block
        .pc-clone
            position relative
            .clone-tipbox
                position absolute
                top 0
                right 0
                p
                    text-align right
                    font-size 12px
                    color rgba(0, 0, 0, 0.5)

        .pc-allow
            margin-top 50px
            .ivu-form-item-content
                margin-left 0 !important

    .publish-modal
        width 950px
        background #fff
        border-radius 8px
        padding 16px 24px
        position absolute
        left 50%
        top 50%
        transform translate(-50%, -50%)
        &--topbar
            height 32px
            line-height 32px
            &--icon
                width 32px
                height 32px
                margin-right 9px
                display inline-block
                vertical-align middle
            &--text
                font-size 14px
                font-weight 700
                vertical-align middle
            &--close
                position absolute
                right 32px
                top 16px
                width 32px
                height 32px
                cursor pointer
                >svg
                    position absolute
                    top 50%
                    left 50%
                    transform translate(-50%, -50%)
                    stroke $modal-title-textcolor
                    width 17px
                    height 17px
        &--content
            margin-top 16px
            height 590px
            overflow-y auto
            padding-right 15px
            &-title
                font-weight 700
                font-size 16px
            &-image
                padding 16px 0
                display flex
                justify-content center
                img
                    width 50%
                    min-width 468px
                    border-radius 22px
                    border 1.37647px solid rgba(0, 0, 0, 0.1)
            &-input
                width 100%
                margin-bottom 6px
            &-textarea
                width 100%
            &-checkbox
                display flex
                align-items center
                flex-wrap wrap
                font-size 16px
            input,textarea
                outline none
                border 1px solid rgba(0, 0, 0, 0.1)
                border-radius 8px
                padding 8px 12px
                font-size 16px
            input:focus,textarea:focus
                border 1px solid var(--themeColor)

        &--footer
            margin-top 16px
            &-btnbox
                display flex
                justify-content flex-end
                margin-top 16px
            &-btn
                display inline-block
                min-width 126px
                height 36px
                padding 0 24px
                text-align center
                line-height 34px
                border 1px solid transparent
                border-radius 8px
                font-size 16px
                cursor pointer
                user-select none
            .linestyle
                border-color var(--themeColor)
                color var(--themeColor)

                &:hover
                    background var(--themeColor)
                    color #fff
            .fillstyle
                background var(--themeColor)
                margin-right 16px
                color #fff
                &:hover
                    background #076cd7
    @media screen and (max-width: 1500px)
        .publish-modal
            width 680px
            &--content
                height 450px
                &-image
                    img
                        min-width unset
                &-checkbox
                    font-size 12px

    .tab-box
        display flex
        flex-wrap wrap
        .tagItem
            border 1px solid rgba(0, 0, 0, 0.4)
            box-sizing border-box
            border-radius 20px
            height 20px
            padding 2px 10px
            text-align center
            line-height 14px
            margin-right 10px
            margin-bottom 5px
            user-select none
            cursor pointer
            &:hover
                color var(--themeColor)
                background #fff
                border-color var(--themeColor)
            &.active
                color #fff
                background var(--themeColor)
                border-color var(--themeColor)
    .pc-tag
        display inline-block
        padding 0 5px
        margin-right 10px
        border-radius 12px
        box-shadow $shadow-card
        margin-bottom 10px
        line-height 20px
        max-width 480px
        word-break break-all

        .tags-delete
            margin-left 5px
            cursor pointer

            &:hover
                stroke #de5145
    .publish-container-en
        .publish-modal--topbar
            position relative
        .publish-modal
            padding: 16px 7px 16px 18px;
        .publish-modal--topbar--close
            position: absolute;
            right: 10px;
            top: 1px;
            width: 25px;
            height: 25px;
            cursor: pointer;
            svg
                color: var(--svg-color-gray-42)
        .publish-modal--content
            &::-webkit-scrollbar
                width: 4px;
                pointer-events: none;
                background: #fff;
            &::-webkit-scrollbar-thumb
                background: #e6e6e6;
            &::-webkit-scrollbar-track
                background: #fff;
            &::-webkit-scrollbar-track-piece
                background: #fff;
            &::-webkit-scrollbar-corner
                background: #fff
    .pc-allow-vip
        margin-top 62px !important
</style>

<template>
    <div class="published-mask" :class="{ 'publish-container-en': !internal }">
        <div v-show="showHint" ref="publishedModel" class="published-model" :style="{ top: `${publishedTop}px`, left: `${publishedLeft}px` }">
            <div class="topbar" @mousedown="move($event)">
                <svg class="item-icon" viewBox="0 0 130 108" xmlns="http://www.w3.org/2000/svg" fill="none">
                    <path
                        d="M63.1847 1.8023L112.414 22.5314C113.941 23.1744 114.657 24.9335 114.014 26.4605C114.012 26.4659 114.01 26.4712 114.007 26.4765L87.8701 87.5571C87.2209 89.0741 85.4685 89.7821 83.9478 89.1417L34.7189 68.4126C33.1919 67.7696 32.4753 66.0105 33.1183 64.4835C33.1205 64.4782 33.1228 64.4728 33.125 64.4675L59.2624 3.38695C59.9115 1.86994 61.664 1.16195 63.1847 1.8023Z"
                        fill="white"
                    />
                    <path
                        opacity="0.237281"
                        d="M63.1844 1.80216L112.327 22.4945C113.854 23.1375 114.57 24.8966 113.927 26.4236C113.925 26.429 113.923 26.4343 113.92 26.4396L87.7834 87.5203C87.1342 89.0373 85.3818 89.7453 83.8611 89.105L34.7189 68.4126C33.1919 67.7696 32.4752 66.0105 33.1182 64.4835C33.1204 64.4782 33.1227 64.4728 33.125 64.4675L59.2621 3.38683C59.9112 1.86981 61.6636 1.16181 63.1844 1.80216Z"
                        fill="url(#publish_def_0)"
                    />
                    <path
                        d="M16.8978 22.3566L67.1259 8.89804C68.7263 8.46921 70.3713 9.41896 70.8002 11.0194L86.5881 69.9408C87.0169 71.5412 86.0672 73.1862 84.4668 73.6151L34.2387 87.0737C32.6383 87.5025 30.9932 86.5527 30.5644 84.9523L14.7765 26.0309C14.3476 24.4305 15.2974 22.7855 16.8978 22.3566Z"
                        fill="white"
                    />
                    <path
                        opacity="0.237281"
                        d="M16.8981 22.3579L67.1043 8.92807C68.7046 8.50265 70.3484 9.4517 70.7801 11.0503L86.6579 70.206C87.0898 71.8055 86.1408 73.4509 84.5406 73.8804C84.5397 73.8807 84.5389 73.8809 84.5374 73.8786L34.3312 87.3084C32.731 87.7338 31.0872 86.7848 30.6554 85.1862L14.7777 26.0305C14.3457 24.431 15.2948 22.7856 16.895 22.3561C16.8958 22.3558 16.8966 22.3556 16.8981 22.3579Z"
                        fill="url(#publish_def_1)"
                    />
                    <path
                        d="M114 78C114.602 78 115.091 78.4884 115.091 79.0909L115.09 80.909L116.909 80.9091C117.512 80.9091 118 81.3975 118 82C118 82.6025 117.512 83.0909 116.909 83.0909L115.09 83.09L115.091 84.9091C115.091 85.5116 114.602 86 114 86C113.398 86 112.909 85.5116 112.909 84.9091L112.909 83.09L111.091 83.0909C110.488 83.0909 110 82.6025 110 82C110 81.3975 110.488 80.9091 111.091 80.9091L112.909 80.909L112.909 79.0909C112.909 78.4884 113.398 78 114 78Z"
                        fill="#6C6FF5"
                    />
                    <path
                        d="M14 6C14.6025 6 15.0909 6.48842 15.0909 7.09091L15.09 8.909L16.9091 8.90909C17.5116 8.90909 18 9.39751 18 10C18 10.6025 17.5116 11.0909 16.9091 11.0909L15.09 11.09L15.0909 12.9091C15.0909 13.5116 14.6025 14 14 14C13.3975 14 12.9091 13.5116 12.9091 12.9091L12.909 11.09L11.0909 11.0909C10.4884 11.0909 10 10.6025 10 10C10 9.39751 10.4884 8.90909 11.0909 8.90909L12.909 8.909L12.9091 7.09091C12.9091 6.48842 13.3975 6 14 6Z"
                        fill="#EDF2FF"
                    />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M4 72C5.65685 72 7 70.6569 7 69C7 67.3431 5.65685 66 4 66C2.34315 66 1 67.3431 1 69C1 70.6569 2.34315 72 4 72Z"
                        stroke="#638DFA"
                        stroke-width="2"
                    />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M126 38C127.657 38 129 36.6569 129 35C129 33.3431 127.657 32 126 32C124.343 32 123 33.3431 123 35C123 36.6569 124.343 38 126 38Z"
                        stroke="#ECF2FF"
                        stroke-width="2"
                    />
                    <path
                        d="M45.3321 21.6724L95.5491 27.6545C97.7428 27.9158 99.3092 29.9059 99.0479 32.0995C99.0468 32.1091 99.0456 32.1187 99.0444 32.1283L91.1095 94.8577C90.8337 97.0381 88.8503 98.5876 86.6679 98.3276L36.4509 92.3455C34.2572 92.0842 32.6908 90.0941 32.9521 87.9005C32.9532 87.8909 32.9544 87.8813 32.9556 87.8717L40.8905 25.1423C41.1663 22.9619 43.1497 21.4124 45.3321 21.6724Z"
                        fill="url(#publish_def_2)"
                    />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M65.9693 51.0086L74.583 54.8409L81.3432 37.8823L55.6704 46.5219L63.7317 50.0561L75.1011 42.6635L65.9693 51.0086ZM65.8516 52.6907L65.2648 57.4701L68.4437 53.8519L65.8516 52.6907Z"
                        fill="#FFFEFF"
                    />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M78.1997 67.1704C78.2357 66.8771 78.0271 66.6101 77.7338 66.5741L52.933 63.529C52.6397 63.4929 52.3728 63.7015 52.3368 63.9948C52.3007 64.2881 52.5093 64.555 52.8026 64.591L77.6034 67.6362C77.8967 67.6722 78.1637 67.4637 78.1997 67.1704ZM82.8131 74.2054C83.1064 74.2414 83.3149 74.5084 83.2789 74.8017C83.2429 75.095 82.976 75.3035 82.6827 75.2675L46.028 70.7669C45.7347 70.7309 45.5262 70.4639 45.5622 70.1706C45.5982 69.8773 45.8651 69.6688 46.1584 69.7048L82.8131 74.2054ZM81.9654 81.109C82.2587 81.145 82.4673 81.412 82.4313 81.7052C82.3953 81.9985 82.1283 82.2071 81.835 82.1711L45.1804 77.6705C44.8871 77.6344 44.6785 77.3675 44.7145 77.0742C44.7505 76.7809 45.0175 76.5724 45.3108 76.6084L81.9654 81.109Z"
                        fill="white"
                    />
                    <defs>
                        <linearGradient id="publish_def_0" x1="138.89" y1="116.321" x2="104.8" y2="-10.7354" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#4A6FFF" stop-opacity="0.985003" />
                            <stop offset="1" stop-color="#D8E5FF" />
                        </linearGradient>
                        <linearGradient id="publish_def_1" x1="142.945" y1="61.4883" x2="45.5721" y2="-15.597" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#4A6FFF" stop-opacity="0.985003" />
                            <stop offset="1" stop-color="#D8E5FF" />
                        </linearGradient>
                        <linearGradient id="publish_def_2" x1="159.501" y1="68.558" x2="58.4208" y2="-26.3053" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#7553F1" />
                            <stop offset="1" stop-color="#56B4FF" />
                        </linearGradient>
                    </defs>
                </svg>
                <iconSymbol class="item-close" name="publish-close" @click.native="closeModel()" />
            </div>
            <p class="text">{{ $t("alreadyPublish") }}</p>
            <div class="btn-box">
                <div class="btn cancel" @click="deleteWork()" v-if="!isBuild">{{ $t("cancelPublish") }}</div>
                <div class="btn ok" @click="toUpdate()">{{ $t("updatePublish") }}</div>
            </div>
        </div>

        <template v-if="internal">
            <Dialog
                v-show="showForm"
                :title="showHint ? $t('alreadyPublish') : $t('publish')"
                :show-footer="!showHint"
                :mask="false"
                tabindex="0"
                :contentWidth="580"
                :contentHeight="330"
                @ok="publish"
                @close="closeModel"
                @keydown.native.stop
            >
                <div class="dialog-publish publish-container publish-container-v1" :style="{ 'padding-bottom': internal ? 0 : '40px' }">
                    <p class="publish-toptips">
                        <span>{{ $t("publishTips") }}</span>
                        <svg style="vertical-align: -3px" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M9.53329 5.21291H5.94646C1.97538 5.21291 1 12.9589 1 12.9589C1 13.976 1.82934 15 2.85514 15H12.6263C13.6487 15 14.4815 13.976 14.4815 12.9589C14.4797 12.9589 13.5044 5.21291 9.53329 5.21291ZM9.88102 7.01047C10.0897 7.13054 10.1592 7.39297 10.041 7.59879L8.81696 9.75998H9.94013C10.0556 9.75998 10.1664 9.80525 10.2481 9.88583C10.3298 9.9664 10.3757 10.0757 10.3757 10.1896C10.3757 10.3036 10.3298 10.4129 10.2481 10.4935C10.1664 10.574 10.0556 10.6193 9.94013 10.6193H8.18236V11.1648H9.93839V11.1665C9.99562 11.1665 10.0523 11.1776 10.1051 11.1993C10.158 11.2209 10.206 11.2527 10.2464 11.2927C10.2867 11.3327 10.3187 11.3801 10.3405 11.4324C10.3622 11.4846 10.3733 11.5405 10.3731 11.597C10.3733 11.6534 10.3622 11.7094 10.3405 11.7616C10.3187 11.8138 10.2867 11.8613 10.2464 11.9013C10.206 11.9413 10.158 11.9731 10.1051 11.9947C10.0523 12.0164 9.99562 12.0275 9.93839 12.0275H8.18236V13.1578C8.18236 13.2716 8.13656 13.3806 8.05505 13.4611C7.97353 13.5415 7.86298 13.5867 7.7477 13.5867C7.63272 13.5862 7.5226 13.5408 7.44147 13.4605C7.36033 13.3801 7.31477 13.2713 7.31477 13.1578V12.0275H5.54657C5.43129 12.0275 5.32073 11.9823 5.23921 11.9019C5.1577 11.8215 5.1119 11.7124 5.1119 11.5987C5.11144 11.5421 5.12235 11.486 5.14399 11.4336C5.16562 11.3811 5.19757 11.3335 5.23798 11.2933C5.27838 11.2531 5.32646 11.2212 5.37942 11.1994C5.43238 11.1777 5.48919 11.1665 5.54657 11.1665H7.31477V10.6227H5.54657C5.43106 10.6227 5.32028 10.5775 5.2386 10.4969C5.15692 10.4163 5.11103 10.307 5.11103 10.1931C5.11103 10.0791 5.15692 9.96984 5.2386 9.88926C5.32028 9.80868 5.43106 9.76341 5.54657 9.76341H6.74276L5.51701 7.60222C5.45926 7.5036 5.4433 7.38648 5.4726 7.27632C5.5019 7.16615 5.5741 7.07185 5.67349 7.0139C5.72282 6.98546 5.77738 6.96697 5.83402 6.95951C5.89065 6.95205 5.94822 6.95577 6.00339 6.97045C6.05855 6.98514 6.11021 7.01049 6.15535 7.04504C6.2005 7.07959 6.23823 7.12264 6.26637 7.1717L7.74074 9.7617H7.8155L9.29162 7.1717C9.3196 7.12273 9.35715 7.07971 9.4021 7.04514C9.44704 7.01057 9.49849 6.98514 9.55346 6.9703C9.60843 6.95547 9.66584 6.95153 9.72236 6.95872C9.77888 6.96591 9.8334 6.98408 9.88276 7.01219L9.88102 7.01047ZM4.09132 2.24728C4.09132 2.24728 4.89283 4.5131 5.94646 4.5131H9.34725C10.4009 4.5131 11.2024 2.24728 11.2024 2.24728C11.2024 1.56977 11.1328 1.0552 9.96447 1.01918C8.7961 0.984877 8.51618 1.83048 7.67641 1.83048C6.81752 1.83048 6.38633 1.16326 5.3275 1.01918C4.26692 0.875103 4.09132 1.56805 4.09132 2.24728Z"
                                fill="#333333"
                            />
                        </svg>
                    </p>
                    <Form ref="form" :model="form" :rules="internalRuleValidate" :label-width="48">
                        <FormItem class="ed-mt-12 ed-mb-24" prop="title" :label="$t('title')">
                            <Input v-model="form.title" :placeholder="$t('titlePlaceholder')" :clearable="true" />
                        </FormItem>
                        <FormItem class="pc-des ed-mt-24 ed-mb-24" prop="description" :label="$t('description')">
                            <Input
                                v-model.trim="form.description"
                                :placeholder="$t('descriptionPlaceholder')"
                                :autosize="{ minRows: 2, maxRows: 6 }"
                                :clearable="true"
                                type="textarea"
                                :maxlength="descritionLimit"
                            />
                            <span
                                :style="{
                                    color: form.description.length >= descritionLimit ? '' : '',
                                }"
                                class="pc-des-count"
                            >
                                {{ `${form.description.length}/${descritionLimit}` }}
                            </span>
                        </FormItem>
                        <Row style="margin-left: 48px">
                            <div v-for="(item, index) in form.tags" :key="item.id" class="pc-tag">
                                <span>{{ item }}</span>
                                <svg
                                    class="tags-delete"
                                    @click="removeTag(index)"
                                    width="8"
                                    height="8"
                                    viewBox="0 0 8 8"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <rect
                                        x="0.444614"
                                        y="7.11076"
                                        width="9.42781"
                                        height="0.62852"
                                        rx="0.31426"
                                        transform="rotate(-45 0.444614 7.11076)"
                                        stroke="#757575"
                                        stroke-width="0.62852"
                                    />
                                    <rect
                                        x="-0.444431"
                                        width="9.42781"
                                        height="0.62852"
                                        rx="0.31426"
                                        transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 7.2411 6.7965)"
                                        stroke="#757575"
                                        stroke-width="0.62852"
                                    />
                                </svg>
                            </div>
                        </Row>
                        <FormItem class="pc-tagipt ed-mt-24 ed-mb-24" prop="tags" :label="$t('tag')">
                            <Input
                                ref="tagIpt"
                                :placeholder="form.tags.length > 0 ? $t('keepAdd') : $t('tagHint')"
                                type="text"
                                @keydown.native.delete="deleteTag($event)"
                                @keydown.native.enter="addTag($event)"
                            />
                            <ul v-show="suggestTags.length > 0" ref="suggest" v-click-outside="onClickSuggestOutside" class="pct-suggest">
                                <li
                                    v-for="(item, index) in suggestTags"
                                    :key="item.id"
                                    :style="{ background: suggestChosen == index ? '#f3f3f3' : '' }"
                                    class="pcts-item"
                                    @click="chooseSuggestTag(item)"
                                >
                                    {{ item }}
                                </li>
                            </ul>
                        </FormItem>

                        <div v-if="false && !internal" style="display: flex; justify-content: space-between; margin-bottom: 14px">
                            <Dropdown trigger="click" class="publish-dropdown" v-if="false">
                                <div class="publish-dropdown-title">
                                    <p>{{ diagramStr.name }}</p>
                                </div>
                                <DropdownMenu v-for="lv1 in diagramList" slot="list" :key="lv1.lv1id">
                                    <Dropdown placement="right-start">
                                        <DropdownItem
                                            @click.native.stop="
                                                setATag('diagram', {
                                                    name: lv1.lv1name,
                                                    data: lv1.lv1id,
                                                })
                                            "
                                        >
                                            {{ lv1.lv1name }}
                                        </DropdownItem>
                                        <DropdownMenu v-for="lv2 in lv1.lv2" slot="list" :key="lv2.lv2id">
                                            <DropdownItem
                                                @click.native.stop="
                                                    setATag('diagram', {
                                                        name: lv2.lv2name,
                                                        data: lv2.lv2id,
                                                    })
                                                "
                                            >
                                                {{ lv2.lv2name }}
                                            </DropdownItem>
                                        </DropdownMenu>
                                    </Dropdown>
                                </DropdownMenu>
                            </Dropdown>

                            <Dropdown trigger="click" class="publish-dropdown" v-if="false">
                                <div class="publish-dropdown-title">
                                    <p>{{ rolesStr.name }}</p>
                                </div>
                                <DropdownMenu v-for="lv1 in rolesList" slot="list" :key="lv1.lv1id">
                                    <DropdownItem @click.native.stop="setATag('roles', { name: lv1.lv1name, data: lv1.lv1id })">
                                        {{ lv1.lv1name }}
                                    </DropdownItem>
                                </DropdownMenu>
                            </Dropdown>

                            <Dropdown trigger="click" class="publish-dropdown">
                                <div class="publish-dropdown-title">
                                    <p>{{ langStr.name }}</p>
                                </div>
                                <DropdownMenu v-for="item in langList" slot="list" :key="item.id">
                                    <DropdownItem @click.native.stop="setATag('lang', { name: item.label, data: item.name })">
                                        {{ item.label }}
                                    </DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </div>

                        <FormItem class="ed-mt-12 ed-mb-24" prop="copyType" :label="$t('clone')">
                            <Row class="pc-clone ed-mt-24 ed-mb-12" type="flex" justify="start" align="middle">
                                <Radio-group v-model="form.copyType" class="publish-radiogroup">
                                    <!-- <Radio label="ban">{{ $t('banClone') }}</Radio> -->
                                    <Radio label="free">{{ $t("freeClone") }}</Radio>
                                    <Radio label="charge">{{ $t("chargeClone") }}</Radio>
                                    <Radio label="vip">{{ $t("vipClone") }}</Radio>
                                </Radio-group>
                                <FormItem v-if="form.copyType == 'charge'" prop="price">
                                    <InputNumber
                                        class="input-num"
                                        :max="maxPrice"
                                        :min="minPrice"
                                        :step="1"
                                        style="width: 130px"
                                        size="small"
                                        v-model="form.price"
                                        :active-change="false"
                                        :placeholder="pricePlaceholder"
                                        :precision="1"
                                    ></InputNumber>
                                </FormItem>
                                <div class="clone-tipbox">
                                    <p>{{ $t("cloneTips") }}</p>
                                    <p>{{ $t("payTips") }}</p>
                                    <p>{{ $t("vipTips") }}</p>
                                </div>
                            </Row>
                        </FormItem>
                        <FormItem class="pc-allow pc-allow-vip" prop="allow">
                            <template v-if="internal">
                                <Checkbox v-model="form.allow">
                                    <span>
                                        {{ $t("readAndAgree") }}
                                    </span>
                                </Checkbox>
                                <span style="color: #017fff; text-decoration: underline; cursor: pointer" @click="showAllowBox()">
                                    {{ $t("publishRules") }}
                                </span>
                            </template>
                            <template v-else>
                                <template v-if="lang != 'jp'">
                                    <Checkbox v-model="form.allow" style="margin-right: 0">
                                        <span>{{ $t("publishRulesAgreeTo") }}</span>
                                    </Checkbox>
                                    <span style="color: #017fff; text-decoration: underline; cursor: pointer" @click="openLink(0)">
                                        {{ $t("publishRulesPolicy") }}
                                    </span>
                                    <span style="color: #017fff; text-decoration: underline; cursor: pointer" @click="openLink(1)">
                                        {{ $t("publishRulesConditions") }}
                                    </span>
                                    <span style="margin: 0 4px">{{ $t("publishRulesAnd") }}</span>
                                    <span style="color: #017fff; text-decoration: underline; cursor: pointer" @click="openLink(2)">
                                        {{ $t("publishRulesCommunity") }}
                                    </span>
                                </template>
                                <template v-else>
                                    <Checkbox v-model="form.allow" style="margin-right: 0"></Checkbox>
                                    <span style="color: #017fff; text-decoration: underline; cursor: pointer" @click="openLink(0)">
                                        {{ "テンプレート公開契約書" }}
                                    </span>
                                    <span style="color: #017fff; text-decoration: underline; cursor: pointer" @click="openLink(1)">
                                        {{ "個人情報保護方針" }}
                                    </span>
                                    <span style="margin: 0 4px">{{ "そして" }}</span>
                                    <span style="color: #017fff; text-decoration: underline; cursor: pointer" @click="openLink(2)">
                                        {{ "コミュニティガイドライン" }}
                                    </span>
                                    <span>
                                        {{ "に同意します" }}
                                    </span>
                                </template>
                            </template>
                        </FormItem>
                    </Form>

                    <!-- <div v-show="showHint" class="pc-hint">
                        <iconSymbol name="publish-icon" />
                        <div class="pch-cancel" @click="deleteWork()">
                            <iconSymbol name="cancelPublish" />
                            <p>{{ $t('cancelPublish') }}</p>
                        </div>
                        <div class="pch-update">
                            <iconSymbol name="updatePublish" @click.native="toUpdate()" />
                            <p>{{ $t('updatePublish') }}</p>
                        </div>
                    </div> -->
                </div>
            </Dialog>
        </template>
        <template v-else>
            <Dialog
                v-if="false"
                v-show="showForm"
                :title="showHint ? $t('alreadyPublish') : $t('publish')"
                :show-footer="!showHint"
                :mask="false"
                tabindex="0"
                :contentWidth="580"
                :contentHeight="330"
                :icon="'publishmodal_icon'"
                @ok="publish"
                @close="closeModel"
                @keydown.native.stop
            >
                <div class="dialog-publish publish-container" :style="{ 'padding-bottom': internal ? 0 : '40px' }">
                    <Form ref="form" :model="form" :rules="ruleValidate">
                        <FormItem class="ed-mt-12 ed-mb-24" prop="title">
                            <Input v-model="form.title" :placeholder="$t('titleHint')" :clearable="true" />
                        </FormItem>
                        <FormItem class="pc-des ed-mt-24 ed-mb-24" prop="description">
                            <Input
                                v-model.trim="form.description"
                                :placeholder="$t('descriptionHint')"
                                :autosize="{ minRows: 2, maxRows: 6 }"
                                :clearable="true"
                                type="textarea"
                                :maxlength="descritionLimit"
                            />
                            <span
                                :style="{
                                    color: form.description.length >= descritionLimit ? '' : '',
                                }"
                                class="pc-des-count"
                            >
                                {{ `${form.description.length}/${descritionLimit}` }}
                            </span>
                        </FormItem>

                        <FormItem class="pc-tagipt ed-mt-24 ed-mb-24" prop="tags">
                            <Row>
                                <div v-for="(item, index) in form.tags" :key="item.id" class="pc-tag">
                                    <span>{{ item }}</span>
                                    <iconSymbol class="pct-delete" name="tagsClose" @click.native="removeTag(index)" />
                                </div>
                            </Row>
                            <Input
                                ref="tagIpt"
                                :placeholder="form.tags.length > 0 ? $t('keepAdd') : $t('tagHint')"
                                type="text"
                                @keyup.native="suggestTag($event)"
                                @keydown.native.delete="deleteTag($event)"
                                @keydown.native.enter="addTag($event)"
                            />
                            <ul v-show="suggestTags.length > 0" ref="suggest" v-click-outside="onClickSuggestOutside" class="pct-suggest">
                                <li
                                    v-for="(item, index) in suggestTags"
                                    :key="item.id"
                                    :style="{ background: suggestChosen == index ? '#f3f3f3' : '' }"
                                    class="pcts-item"
                                    @click="chooseSuggestTag(item)"
                                >
                                    {{ item }}
                                </li>
                            </ul>
                        </FormItem>

                        <Row class="pc-clone ed-mt-24 ed-mb-12" type="flex" justify="start" align="middle" v-show="internal">
                            <Radio-group v-model="form.copyType" class="pcc-type">
                                <!-- <Radio label="ban">{{ $t('banClone') }}</Radio> -->
                                <Radio label="free">{{ $t("freeClone") }}</Radio>
                                <Radio label="charge">{{ $t("chargeClone") }}</Radio>
                            </Radio-group>
                            <FormItem v-if="form.copyType == 'charge'" prop="price">
                                <!-- <InputNumber
                                    ref="chargeIpt"
                                    v-model="form.price"
                                    :placeholder="$t('clonePrice')"
                                    size="small"
                                    class="pcc-price"
                                /> -->
                                <input v-model="form.price" style="display: none" />
                                <Dropdown @on-click="selectPrice" :trigger="'click'">
                                    <p class="ivu-input pcc-price" ref="chargeIpt">
                                        {{ form.price + $t("currency.unit") }}
                                    </p>
                                    <Icon type="ios-arrow-down" class="icon-arrow"></Icon>
                                    <DropdownMenu slot="list">
                                        <DropdownItem :name="5">{{ "5" + $t("currency.unit") }}</DropdownItem>
                                        <DropdownItem :name="10">{{ "10" + $t("currency.unit") }}</DropdownItem>
                                        <DropdownItem :name="15">{{ "15" + $t("currency.unit") }}</DropdownItem>
                                        <DropdownItem :name="20">{{ "20" + $t("currency.unit") }}</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </FormItem>
                        </Row>
                        <FormItem class="pc-allow" prop="allow">
                            <template v-if="internal">
                                <Checkbox v-model="form.allow">
                                    <span>
                                        {{ $t("readAndAgree") }}
                                    </span>
                                </Checkbox>
                                <span style="color: #017fff; text-decoration: underline; cursor: pointer" @click="showAllowBox()">
                                    {{ $t("publishRules") }}
                                </span>
                            </template>
                            <template v-else>
                                <template v-if="lang != 'jp'">
                                    <Checkbox v-model="form.allow" style="margin-right: 0">
                                        <span>{{ $t("publishRulesAgreeTo") }}</span>
                                    </Checkbox>
                                    <span style="color: #017fff; text-decoration: underline; cursor: pointer" @click="openLink(0)">
                                        {{ $t("publishRulesPolicy") }}
                                    </span>
                                    <span style="color: #017fff; text-decoration: underline; cursor: pointer" @click="openLink(1)">
                                        {{ $t("publishRulesConditions") }}
                                    </span>
                                    <span style="margin: 0 4px">{{ $t("publishRulesAnd") }}</span>
                                    <span style="color: #017fff; text-decoration: underline; cursor: pointer" @click="openLink(2)">
                                        {{ $t("publishRulesCommunity") }}
                                    </span>
                                </template>
                                <template v-else>
                                    <Checkbox v-model="form.allow" style="margin-right: 0"></Checkbox>
                                    <span style="color: #017fff; text-decoration: underline; cursor: pointer" @click="openLink(0)">
                                        {{ "テンプレート公開契約書" }}
                                    </span>
                                    <span style="color: #017fff; text-decoration: underline; cursor: pointer" @click="openLink(1)">
                                        {{ "個人情報保護方針" }}
                                    </span>
                                    <span style="margin: 0 4px">{{ "そして" }}</span>
                                    <span style="color: #017fff; text-decoration: underline; cursor: pointer" @click="openLink(2)">
                                        {{ "コミュニティガイドライン" }}
                                    </span>
                                    <span>
                                        {{ "に同意します" }}
                                    </span>
                                </template>
                            </template>
                        </FormItem>
                    </Form>

                    <!-- <div v-show="showHint" class="pc-hint">
                        <iconSymbol name="publish-icon" />
                        <div class="pch-cancel" @click="deleteWork()">
                            <iconSymbol name="cancelPublish" />
                            <p>{{ $t('cancelPublish') }}</p>
                        </div>
                        <div class="pch-update">
                            <iconSymbol name="updatePublish" @click.native="toUpdate()" />
                            <p>{{ $t('updatePublish') }}</p>
                        </div>
                    </div> -->
                </div>
            </Dialog>

            <div class="publish-modal" v-show="showForm">
                <div class="publish-modal--topbar">
                    <span class="publish-modal--topbar--text">{{ $t("publish") }}</span>

                    <div class="publish-modal--topbar--close" @click="closeModel">
                        <iconSymbol name="Del" />
                    </div>
                </div>

                <div class="publish-modal--content">
                    <p class="publish-modal--content-title">{{ $t("preview") }}:</p>
                    <div class="publish-modal--content-image">
                        <img :src="previewUrl" alt="" />
                    </div>
                    <Form ref="form" :model="form" :rules="ruleValidate">
                        <FormItem prop="title">
                            <input v-model="form.title" :placeholder="$t('titleHint')" class="publish-modal--content-input" type="text" />
                        </FormItem>
                        <FormItem prop="description">
                            <textarea
                                v-model.trim="form.description"
                                :placeholder="$t('descriptionHint')"
                                :maxlength="descritionLimit"
                                class="publish-modal--content-textarea"
                                rows="5"
                            ></textarea>
                            <span
                                :style="{
                                    color: form.description.length > descritionLimit ? '' : '',
                                }"
                                style="position: absolute; right: 20px; bottom: 10px"
                            >
                                {{ `${form.description.length}/${descritionLimit}` }}
                            </span>
                        </FormItem>

                        <Row>
                            <div v-for="(item, index) in form.tags" :key="item.id" class="pc-tag">
                                <span>{{ item }}</span>
                                <svg
                                    class="tags-delete"
                                    @click="removeTag(index)"
                                    width="8"
                                    height="8"
                                    viewBox="0 0 8 8"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <rect
                                        x="0.444614"
                                        y="7.11076"
                                        width="9.42781"
                                        height="0.62852"
                                        rx="0.31426"
                                        transform="rotate(-45 0.444614 7.11076)"
                                        stroke="#757575"
                                        stroke-width="0.62852"
                                    />
                                    <rect
                                        x="-0.444431"
                                        width="9.42781"
                                        height="0.62852"
                                        rx="0.31426"
                                        transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 7.2411 6.7965)"
                                        stroke="#757575"
                                        stroke-width="0.62852"
                                    />
                                </svg>
                            </div>
                        </Row>

                        <FormItem class="ed-mt-24 ed-mb-24" prop="tags">
                            <Input
                                ref="tagIpt"
                                :placeholder="form.tags.length > 0 ? $t('keepAdd') : $t('tagHint')"
                                type="text"
                                :maxlength="255"
                                @keydown.native.enter="addTag($event)"
                            />
                        </FormItem>

                        <div class="tab-box">
                            <div
                                class="tagItem"
                                :class="{ active: form.tags.includes(item) }"
                                :key="idx"
                                v-for="(item, idx) in tagList"
                                @click="form.tags.includes(item) ? removeTagByName(item) : selectTag(item)"
                            >
                                <span>{{ item }}</span>
                            </div>
                        </div>

                        <FormItem prop="allow">
                            <div class="publish-modal--content-checkbox">
                                <template v-if="lang != 'jp'">
                                    <Checkbox v-model="form.allow" style="margin-right: 0"></Checkbox>
                                    <span style="margin-left: 10px">{{ $t("publishRulesAgreeTo") }}</span>
                                    <span style="color: #017fff; text-decoration: underline; cursor: pointer" @click="openLink(0)">
                                        {{ $t("publishRulesPolicy") }}
                                    </span>
                                    <span style="color: #017fff; text-decoration: underline; cursor: pointer" @click="openLink(1)">
                                        {{ $t("publishRulesConditions") }}
                                    </span>
                                    <span style="margin: 0 4px">{{ $t("publishRulesAnd") }}</span>
                                    <span style="color: #017fff; text-decoration: underline; cursor: pointer" @click="openLink(2)">
                                        {{ $t("publishRulesCommunity") }}
                                    </span>
                                </template>
                                <template v-else>
                                    <Checkbox v-model="form.allow" style="margin-right: 0"></Checkbox>
                                    <span style="color: #017fff; text-decoration: underline; cursor: pointer" @click="openLink(0)">
                                        {{ "テンプレート公開契約書" }}
                                    </span>
                                    <span style="color: #017fff; text-decoration: underline; cursor: pointer" @click="openLink(1)">
                                        {{ "個人情報保護方針" }}
                                    </span>
                                    <span style="margin: 0 4px">{{ "そして" }}</span>
                                    <span style="color: #017fff; text-decoration: underline; cursor: pointer" @click="openLink(2)">
                                        {{ "コミュニティガイドライン" }}
                                    </span>
                                    <span>
                                        {{ "に同意します" }}
                                    </span>
                                </template>
                            </div>
                        </FormItem>
                    </Form>
                </div>

                <div class="publish-modal--footer">
                    <div class="publish-modal--footer-checkbox"></div>
                    <div class="publish-modal--footer-btnbox">
                        <div class="publish-modal--footer-btn fillstyle" @click="publish">{{ $t("publish") }}</div>
                        <div class="publish-modal--footer-btn linestyle" @click="closeModel">{{ $t("cancel") }}</div>
                    </div>
                </div>
            </div>
        </template>
        <Modal class="allow-modal" v-model="showAllowModal" title="模板发布须知">
            <p>发布前请认真阅读以下须知：</p>
            <p>1. 模板内容必须符合国家法律法规，不涉及色情暴力以及其他国家不允许的内容。</p>
            <p>2. 模板内容不得侵犯他人版权。</p>
            <p>3. 用户直接克隆使用他人作品的不予通过。</p>
            <p>4. 标题过短、内容不一致、或者描述不清晰的不予通过。</p>
            <p>5. 模板的价格设定需与模板价值匹配。如果出现明显不匹配的情况，允许审核人员适当调整价格。</p>
            <p>6. 允许审核人员进行内容纠错和外观设计优化。</p>
            <p>7. 当公司有促销活动时，允许统一在设定的价格基础上统一进行一定的折扣。</p>
            <p>8. 其他用户购买您的付费模板后，平台会收取成交额的30% 作为服务费，剩余的70%作为您的收益，可以到个人中心提现。</p>
        </Modal>
    </div>
</template>
<script lang="ts">
    import Dialog from "../Dialog.vue";
    import appConfig from "@/public/globalConfig";
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    import { isEmpty } from "@/public/utils/tool";

    declare var egSize: any;
    @Component({
        components: {
            Dialog,
        },
    })
    export default class Publish extends Vue {
        @Inject()
        ["showMessage"];
        //发布需要的信息
        form: any = {
            title: "",
            description: "",
            price: "",
            copyType: "free",
            tags: [],
            allow: false,
        };
        isBuild = appConfig.isBuild;
        //其他数据
        suggestTags = [];
        blacklistTags = [];
        suggestChosen = -1;
        //当前文件发布状态
        publishType: string = "newPublish";
        workId: number = undefined;
        showHint: boolean = false;
        showForm: boolean = false;
        deleteFlag: boolean = false;

        publishedX: number = 0;
        publishedY: number = 0;
        publishedLeft: number = 0;
        publishedTop: number = 0;

        showAllowModal: boolean = false;

        diagramList: Array<object> = [];
        rolesList: Array<object> = [];
        langList: Array<Object> = [
            {
                id: 1,
                name: "en",
                label: "English",
            },
            {
                id: 2,
                name: "de",
                label: "Deutsch",
            },
            {
                id: 3,
                name: "fr",
                label: "Francais",
            },
            {
                id: 4,
                name: "jp",
                label: "日本语",
            },
            {
                id: 5,
                name: "es",
                label: "Español",
            },
            {
                id: 6,
                name: "it",
                label: "Italiano",
            },
            {
                id: 7,
                name: "pt",
                label: "Português",
            },
        ];

        diagramStr: object = {
            name: "",
            data: null,
        };
        rolesStr: object = {
            name: "",
            data: null,
        };
        langStr: object = {
            name: "en",
            data: "en",
        };

        libInfo = null;
        dbInfo = null;
        getDbInfoDone = false;
        previewUrl = "";
        tagList = [];

        get descritionLimit() {
            return this.internal ? 250 : 10000;
        }
        get userInfo() {
            return this.$store.state.user.userInfo;
        }
        get internalRuleValidate() {
            return {
                copyType: [
                    {
                        type: "string",
                        required: true,
                        validator: (rule, value, callback) => {
                            callback();
                        },
                    },
                ],
                allow: [
                    {
                        type: "boolean",
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value == true) {
                                callback();
                            } else {
                                callback(new Error(this.$t("validateWarn.agree") as string));
                            }
                        },
                    },
                ],
            };
        }
        get ruleValidate() {
            return {
                title: [
                    {
                        required: true,
                        message: this.$t("validateWarn.titleRequire"),
                        trigger: "blur",
                    },
                    {
                        pattern: /^([^?*:"<>\\/|$%^#&+]+)$/,
                        message: this.$t("validateWarn.titleFormat") + '? * : " < > \\ / | $ % ^ # & +',
                        trigger: "blur",
                    },
                ],
                description: [
                    {
                        required: true,
                        message: this.$t("validateWarn.desRequire"),
                        trigger: "blur",
                    },
                    {
                        type: "string",
                        min: 15,
                        message: this.$t("validateWarn.desLength"),
                        trigger: "blur",
                    },
                ],
                allow: [
                    {
                        type: "boolean",
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value == true) {
                                callback();
                            } else {
                                callback(new Error(this.$t("validateWarn.agree") as string));
                            }
                        },
                    },
                ],
            };
        }
        //是否正在发布
        isPublishing: boolean = false;

        onClickSuggestOutside() {
            this.suggestTags = [];
        }
        toUpdate() {
            this.showHint = false;
            this.showForm = true;
        }
        focusTagIpt() {
            (<HTMLInputElement>this.$refs.tagIpt).focus();
        }
        // 选择价格
        selectPrice(v) {
            this.form.price = v;
        }
        // 显示模板发布须知
        showAllowBox() {
            this.showAllowModal = true;
        }
        coverWidth = 0;
        coverHeight = 0;
        publish() {
            if (!this.canPublish) {
                this.$edMessage.warning(this.$t("cloneBan"));
                return;
            }
            if (!this.getDbInfoDone) return;
            let ts: any = this;
            let curFileKey = this.customLibraryPath + `${this.libInfo.tb}.edt`;
            if (this.libInfo.tableID == this.$store.state.library.collectTBID) {
                curFileKey = this.collectTBEdtKey;
            }

            let publishInfo = {};
            let uploadFunc = (response) => {
                let promiseList = [];
                let ossData = response;
                if (!this.internal) {
                    ossData["host"] = ossData.action;
                }
                let ts = this;
                let imgform = new FormData(),
                    svgform = new FormData(),
                    edlform = new FormData(),
                    edtform = new FormData();
                if (this.internal) {
                    imgform.append("OSSAccessKeyId", ossData.id);
                    imgform.append("policy", ossData.policy);
                    imgform.append("Signature", ossData.sign);
                    imgform.append("key", ossData.path + ossData.uri + `thumb.png`);
                    imgform.append("file", this.dbInfo.blob);

                    svgform.append("OSSAccessKeyId", ossData.id);
                    svgform.append("policy", ossData.policy);
                    svgform.append("Signature", ossData.sign);
                    svgform.append("key", ossData.path + ossData.uri + `main.svg`);
                    svgform.append("file", this.dbInfo.svg);
                } else {
                    imgform.append("X-Amz-Algorithm", ossData["X-Amz-Algorithm"]);
                    imgform.append("X-Amz-Credential", ossData["X-Amz-Credential"]);
                    imgform.append("X-Amz-Date", ossData["X-Amz-Date"]);
                    imgform.append("X-Amz-Signature", ossData["X-Amz-Signature"]);
                    imgform.append("acl", ossData["acl"]);
                    imgform.append("Policy", ossData["Policy"]);
                    imgform.append("key", ossData.path + ossData.uri + `thumb.png`);
                    imgform.append("file", this.dbInfo.blob);

                    svgform.append("X-Amz-Algorithm", ossData["X-Amz-Algorithm"]);
                    svgform.append("X-Amz-Credential", ossData["X-Amz-Credential"]);
                    svgform.append("X-Amz-Date", ossData["X-Amz-Date"]);
                    svgform.append("X-Amz-Signature", ossData["X-Amz-Signature"]);
                    svgform.append("acl", ossData["acl"]);
                    svgform.append("Policy", ossData["Policy"]);
                    svgform.append("key", ossData.path + ossData.uri + "main.svg");
                    svgform.append("file", this.dbInfo.svg);
                }

                // edlform.append("X-Amz-Algorithm", ossData["X-Amz-Algorithm"]);
                // edlform.append("X-Amz-Credential", ossData["X-Amz-Credential"]);
                // edlform.append("X-Amz-Date", ossData["X-Amz-Date"]);
                // edlform.append("X-Amz-Signature", ossData["X-Amz-Signature"]);
                // edlform.append("acl", ossData["acl"]);
                // edlform.append("Policy", ossData["Policy"]);
                // edlform.append("key", ossData.path + ossData.uri + 'lib.edl');
                // edlform.append("file", this.dbInfo.edlFile);

                // edtform.append("X-Amz-Algorithm", ossData["X-Amz-Algorithm"]);
                // edtform.append("X-Amz-Credential", ossData["X-Amz-Credential"]);
                // edtform.append("X-Amz-Date", ossData["X-Amz-Date"]);
                // edtform.append("X-Amz-Signature", ossData["X-Amz-Signature"]);
                // edtform.append("acl", ossData["acl"]);
                // edtform.append("Policy", ossData["Policy"]);
                // edtform.append("key", ossData.path + ossData.uri + 'lib.edt');
                // edtform.append("file", this.dbInfo.edtFile);

                let addTask = (data) => {
                    promiseList.push(
                        new Promise((rs, rj) => {
                            let param = { url: ossData.host, data: data };
                            ts.$edApi
                                .uploadFile(param)
                                .then((res) => {
                                    rs(null);
                                })
                                .catch((err) => {
                                    console.log(err);
                                });
                        })
                    );
                };
                addTask(imgform);
                addTask(svgform);
                promiseList.push(
                    new Promise((resolve) => {
                        let img = new Image();
                        const url = URL.createObjectURL(this.dbInfo.blob);
                        img.src = url;
                        img.onload = () => {
                            this.coverWidth = img.width;
                            this.coverHeight = img.height;
                            URL.revokeObjectURL(url);
                            resolve(null);
                        };
                    })
                );
                // addTask(edtform);
                // addTask(edlform);

                publishInfo = Object.assign(publishInfo, {
                    graph_num: this.libInfo.data.length || 0,
                });

                Promise.all(promiseList).then((e) => {
                    console.log("upload success");
                    let closeLoading = () => {
                        this.isPublishing = false;
                        this.$store.commit("setStatus", {
                            type: "ShareLoading",
                            data: false,
                        });
                    };
                    if (this.publishType == "updatePublish") {
                        publishInfo = Object.assign(publishInfo, {
                            workId: this.workId,
                        });
                        let obj = {
                            id: this.userInfo.user_id,
                            token: this.userInfo.token,
                            data: publishInfo,
                        };
                        if (!this.internal) {
                            obj.data["lang"] = this.lang;
                        }
                        obj.data["cover_height"] = this.coverHeight;
                        obj.data["cover_width"] = this.coverWidth;
                        if (!this.internal && ["pt", "it"].includes(obj.data["lang"])) {
                            obj.data["lang"] = "en";
                        }
                        this.$edApi
                            .updatePublish(obj)
                            .then((e) => {
                                console.log("update publish success");
                                this.$store.commit("setDialogState", {
                                    type: "showDialog",
                                    data: false,
                                });
                                this.$edMessage.success(this.$t("message.publishSuccess"));
                                closeLoading();
                                this.showPublishSymbol = false;
                                this.refreshForm();
                                ts.showMessage({
                                    type: 0,
                                    imgType: 3,
                                    content: this.$t("updateOK"),
                                    avoid: true,
                                    avoidTitle: "changePublish",
                                });
                            })
                            .catch(() => {
                                closeLoading();
                            });
                    } else {
                        let obj = {
                            id: ts.userInfo.user_id,
                            token: ts.userInfo.token,
                            data: Object.assign(publishInfo, {
                                author: ts.userInfo.nick_name,
                                url: ossData.path + ossData.uri,
                                obj: curFileKey,
                                exp: 2147483647,
                                id: ts.userInfo.user_id,
                            }),
                        };
                        if (this.$store.state.ui.album.id != -1) {
                            obj.data["album"] = [this.$store.state.ui.album.id];
                        }
                        if (!this.internal) {
                            obj.data["lang"] = this.lang;
                        }
                        obj.data["cover_height"] = this.coverHeight;
                        obj.data["cover_width"] = this.coverWidth;
                        if (!this.internal && ["pt", "it"].includes(obj.data["lang"])) {
                            obj.data["lang"] = "en";
                        }
                        ts.$edApi
                            .publishFile(obj)
                            .then((e) => {
                                console.log("publish success");
                                ts.$store.commit("setDialogState", {
                                    type: "showDialog",
                                    data: false,
                                });
                                ts.$edMessage.success(ts.$t("message.publishSuccess"));
                                closeLoading();
                                ts.showPublishSymbol = false;
                                ts.refreshForm();
                                ts.showMessage({
                                    type: 0,
                                    imgType: 3,
                                    content: this.$t("publishOK"),
                                    avoid: true,
                                    avoidTitle: "publish",
                                });
                            })
                            .catch((err) => {
                                if (err.msg == "title over 255 characters") {
                                    ts.$edMessage.error(ts.$t("message.publishError.titleOver255"));
                                } else if (err.msg == "title ERR_ILLEGALWORD") {
                                    ts.$edMessage.error(ts.$t("message.publishError.titleERR_ILLEGALWORD") + ":" + err.words.join(","));
                                } else if (err.msg == "description over 255 characters") {
                                    ts.$edMessage.error(ts.$t("message.publishError.descriptionOver255"));
                                } else if (err.msg == "description ERR_ILLEGALWORD") {
                                    ts.$edMessage.error(ts.$t("message.publishError.descriptionERR_ILLEGALWORD") + ":" + err.words.join(","));
                                } else ts.$edMessage.error(ts.$t("message.publishError.other"));
                                closeLoading();
                            });
                    }
                });
            };
            //校验表单
            const map = new Map([
                ["charge", 0],
                ["free", 0],
                ["vip", 1],
            ]);
            let title = this.form.title,
                tag = [].concat(this.form.tags),
                description = this.form.description,
                price = this.form.price,
                member_free = map.get(this.form.copyType);

            (<any>this.$refs.form).validate((pass) => {
                if (!pass) {
                    return;
                }
                if (this.isPublishing) return;
                if (this.form.copyType === "charge") {
                    if (isEmpty(this.form.price)) {
                        this.$edMessage.error("请输入费用");
                        return;
                    }
                }
                this.isPublishing = true;

                this.$store.commit("setStatus", {
                    type: "ShareLoading",
                    data: true,
                });

                //发布
                publishInfo = {
                    title,
                    description,
                    copy: 1,
                    price: 0,
                    tag,
                };

                if (this.internal) {
                    if (this.form.copyType == "free" || this.form.copyType == "vip") {
                        price = 0;
                    }
                    Object.assign(publishInfo, {
                        price,
                        member_free,
                        album: [
                            {
                                id: 2000,
                                title: "优质流程图 含多种场景",
                                cover_url: "maxalbum/1600926777/",
                            },
                        ],
                    });
                }

                if (this.publishType == "updatePublish") {
                    this.$edApi
                        .getUpdateLink({
                            id: this.userInfo.user_id,
                            token: this.userInfo.token,
                            workId: this.workId,
                        })
                        .then((e) => {
                            uploadFunc(e.data);
                        });
                } else {
                    this.$edApi
                        .getPublishLink({
                            id: this.userInfo.user_id,
                            token: this.userInfo.token,
                        })
                        .then((e) => {
                            uploadFunc(e.data);
                        });
                }
            });
        }
        //取消发布
        deleteWork() {
            //删除作品
            if (this.deleteFlag) {
                return;
            }
            this.deleteFlag = true;
            let params = {
                id: this.userInfo.user_id,
                token: this.userInfo.token,
                workId: this.workId,
            };
            this.$edApi
                .deletePublish(params)
                .then(() => {
                    //删除成功之后关闭窗口
                    this.closeModel();
                    this.deleteFlag = false;
                    this.$edMessage.success(this.$t("message.cancelSuccess"));
                    this.refreshForm();
                })
                .catch(() => {
                    this.deleteFlag = false;
                });
        }
        beforeUpdate() {
            if (!this.showPublishSymbol) return;
        }
        get customLibraryPath() {
            return this.$store.state.library.customLibraryPath;
        }
        refreshForm() {
            (<any>this.$refs.form).resetFields();
            let ts: any = this;
            let filePath = this.customLibraryPath + `${this.libInfo.tb}.edt`;
            if (this.libInfo.tableID == this.$store.state.library.collectTBID) {
                filePath = this.collectTBEdtKey;
            }
            this.initTagList();
            this.$edApi
                .getWorkInfo({
                    id: this.userInfo.user_id,
                    curFileKey: filePath,
                    token: this.userInfo.token,
                    platform: this.$store.state.publicStore.runPlatform,
                })
                .then((workInfo) => {
                    console.log(workInfo);
                    if (workInfo == "not found") {
                        this.publishType = "newPublish";
                        this.showForm = true;
                        this.showHint = false;
                    } else {
                        console.log(workInfo);
                        this.publishType = "updatePublish";
                        this.workId = workInfo.id;
                        this.showForm = false;
                        this.showHint = true;
                        this.initPosition();
                        this.form.title = workInfo.title;
                        this.form.description = workInfo.description;
                        this.form.tags = workInfo.tags;
                        if (workInfo.allow_copy == 0) {
                            this.form.copyType = "ban";
                        } else if (workInfo.price > 0) {
                            this.form.copyType = "charge";
                            this.form.price = Number(workInfo.price);
                        } else {
                            this.form.price = "";
                            this.form.copyType = workInfo.member_free == 1 ? "vip" : "free";
                        }
                    }
                });
        }
        initTagList() {
            this.$edApi.getTagClass({ lang: this.lang }).then((e) => {
                this.tagList.length = 0;
                for (let i = 1; i < e.length; i++) {
                    this.tagList.push(e[i].lv1name);
                }
            });
        }
        addTag(e) {
            console.log(e);
            if (this.form.tags.length >= 5) {
                return;
            }
            let str = e.target.value;
            str = str.trim();
            // if(!this.tagList.includes(str))
            //     this.tagList.push(str);

            let index = this.form.tags.indexOf(str);
            if (index == -1) {
                this.form.tags.push(str);
            }
            this.$nextTick(() => {
                e.target.value = "";
            });
        }
        selectTag(item) {
            if (this.form.tags.length >= 5) {
                return;
            }
            let index = this.form.tags.indexOf(item);
            if (index == -1) {
                this.form.tags.push(item);
            } else {
                this.form.tags.splice(index, 1);
            }
        }
        removeTag(index) {
            this.form.tags.splice(index, 1);
        }
        removeTagByName(name: string) {
            const index = this.form.tags.indexOf(name);
            ~index && this.form.tags.splice(index, 1);
        }

        move(e) {
            return;
            this.publishedX = e.clientX;
            this.publishedY = e.clientY;
            let left = this.publishedLeft;
            let top = this.publishedTop;
            document.onmousemove = (e) => {
                this.publishedLeft = left + e.clientX - this.publishedX;
                this.publishedTop = top + e.clientY - this.publishedY;
            };
            document.onmouseup = () => {
                document.onmousemove = null;
            };
        }
        initPosition() {
            this.$nextTick(() => {
                let dom = this.$refs.publishedModel as HTMLElement;
                if (!dom) return;
                this.publishedLeft = (document.documentElement.clientWidth - dom.clientWidth) / 2;
                this.publishedTop = (document.documentElement.clientHeight - dom.clientHeight) / 2;
            });
        }
        closeModel() {
            this.$edMessage.destroy();
            this.showPublishSymbol = false;
            this.showHint = false;
            this.showForm = false;
        }
        get showPublishSymbol() {
            return this.$store.state.ui.showPublishSymbol;
        }
        set showPublishSymbol(v) {
            this.$store.commit("setStatus", {
                type: "showPublishSymbol",
                data: v,
            });
        }

        setATag(type, data) {
            switch (type) {
                case "diagram": {
                    this.diagramStr = data;
                    break;
                }
                case "roles": {
                    this.rolesStr = data;
                    break;
                }
                case "lang": {
                    this.langStr = data;
                    break;
                }
            }
        }
        // 打开链接
        openLink(type) {
            let arr = ["en", "zh", "fr", "de", "rs"].includes(this.lang)
                ? [
                      "https://www.edrawsoft.com/privacy-policy.html ",
                      "https://www.edrawsoft.com/terms-conditions.html",
                      "https://www.edrawsoft.com/community-guidelines.html",
                  ]
                : [
                      `https://www.edrawsoft.com/${this.lang}/privacy-policy.html`,
                      `https://www.edrawsoft.com/${this.lang}/terms-conditions.html`,
                      `https://www.edrawsoft.com/${this.lang}/community-guidelines.html`,
                  ];
            let url = arr[type];
            window.open(url);
        }

        get collectTBEdtKey() {
            return this.$store.state.library.collectTBEdtKey;
        }
        canPublish = false;
        minPrice = 3;
        maxPrice = 20;
        get pricePlaceholder() {
            return `价格范围 ${this.minPrice}-${this.maxPrice}元`;
        }
        mounted() {
            if (this.internal) {
                this.$edApi.getPublishPrice().then((result) => {
                    const min_price = Number(result.min_price);
                    const max_price = Number(result.max_price);
                    if (min_price) {
                        this.minPrice = min_price;
                    }
                    if (max_price) {
                        this.maxPrice = max_price;
                    }
                });
            }
        }
        created() {
            this.$edMessage.config({
                top: window.innerHeight / 2 - 27,
            });
            this.$bus.$on("publishSymbolInfo", (e) => {
                this.libInfo = e;
                let list = this.$store.state.library.menuList[0];
                for (let item of list.children) {
                    if (item.id == e.tableID) {
                        this.canPublish = !(item.cloneID > 0 && !item.modifiedFromClone);
                    }
                }
                this.refreshForm();
                window["_view"].saveLibrayAsPreview(this.libInfo.data, this.libInfo.db, this.libInfo.tb).then((obj) => {
                    this.dbInfo = obj;
                    this.getDbInfoDone = true;
                    this.previewUrl = URL.createObjectURL(obj.blob);
                    this.form.title = this.libInfo.tableID == this.$store.state.library.collectTBID ? "" : this.libInfo.tb;
                });
            });
            this.$once("hook:beforeDestroy", () => {
                this.$bus.$off("publishSymbolInfo");
                URL.revokeObjectURL(this.previewUrl);
            });
            if (!this.internal) {
                // this.$edApi.getTagClass({group: 'default', lang: this.lang}).then(e => {
                //     e.shift();
                //     this.diagramList = e;
                //     this.diagramStr = {
                //         name: e[0].lv1name,
                //         data: e[0].lv1id,
                //     }
                // })
                // this.$edApi.getTagClass({group: 'role',lang: this.lang}).then(e => {
                //     e.shift();
                //     this.rolesList = e;
                //     this.rolesStr = {
                //         name: e[0].lv1name,
                //         data: e[0].lv1id,
                //     }
                // })
                let index = 0;
                for (let i = 0; i < this.langList.length; i++) {
                    if (this.langList[i]["name"] == this.lang) {
                        index = i;
                        break;
                    }
                }
                this.langStr = {
                    name: this.langList[index]["label"],
                    data: this.langList[index]["name"],
                };
            }
        }
        beforeDestroy() {
            this.$edMessage.config({
                top: 50,
            });
        }
    }
</script>
<i18n>
{
  "zh": {
    "alreadyPublish": "文件已发布，您可以",
    "publish": "发布",
    "cancel": "取消",
    "titleHint": "标题*",
    "descriptionHint": "描述（15个字符以上）*",
    "keepAdd": "继续添加标签",
    "tagHint": "标签，按回车添加新标签*",
    "banClone": "禁止克隆",
    "vipClone": "会员免费",
    "freeClone": "免费克隆",
    "chargeClone": "付费克隆",
    "clonePrice": "克隆价格",
    "cancelPublish": "取消发布",
    "updatePublish": "更新发布信息",
    "readAndAgree": "我已阅读并同意",
    "publishRules": "《模板发布须知》",
    "publishRulesAgreeTo": "我已阅读并接受",
    "publishRulesPolicy": "隐私政策，",
    "publishRulesConditions": "服务条款，",
    "publishRulesAnd": " 和 ",
    "publishRulesCommunity": "社区公约。",
    "currency": {
      "unit": "元",
      "symbol": "￥"
    },
    "validateWarn": {
      "titleRequire": "标题不能为空！",
      "titleFormat": "标题不能包含以下字符： ",
      "desRequire": "描述不能为空！",
      "desLength": "描述不能少于15个字符！",
      "priceRequire": "价格不能为空！",
      "priceRange": "价格需要在1-10元之间！",
      "tagRequire": "请至少添加一个标签！",
      "agree": "请阅读并勾选同意模板发布须知"
    },
    "message": {
      "publishSuccess": "发布成功！",
      "cancelSuccess": "取消发布成功！",
      "invalidTag": "该标签不可用！",
      "toolong": "超过20字节！",
      "publishError": {
        "titleOver255": "标题超过255个字符",
        "titleERR_ILLEGALWORD": "标题中存在敏感词",
        "descriptionOver255": "描述超过255个字符",
        "descriptionERR_ILLEGALWORD": "描述中存在敏感词",
        "other": "发布失败"
      }
    },
    "publishTips": "您可以选择您所绘制的文件发布至模板社区，供用户学习交流，并可以设置价格，从而获取一定的报酬。",
    "title": "标题",
    "titlePlaceholder": "请输入导图标题（80个字符以内）",
    "description": "描述",
    "descriptionPlaceholder": "充分的描述更容易让模板审核通过哦~",
    "tag": "标签",
    "clone": "克隆",
    "cloneTips": "所有用户都可以免费克隆您的文件",
    "payTips": "用户付费后，可以克隆您的文件",
    "vipTips": "亿图图示的会员可以免费克隆您的文件",
    "updateOK": "您修改的模板已进入审核状态，我们会在7个工作日内完成审核，一旦审核结束，将在模板社区公开。",
    "publishOK": "您发布的模板已进入审核状态，我们会在7个工作日内完成审核，一旦审核结束，将在模板社区公开。",
    "preview": "档案预览",
    "cloneBan": "克隆的文件不允许直接发布"
  },
  "en": {
    "alreadyPublish": "The document is published. You can",
    "publish": "Publish",
    "cancel": "Cancel",
    "titleHint": "Title*",
    "descriptionHint": "Description（Description should be at least 15 characters in length）*",
    "keepAdd": "Add more tags",
    "tagHint": "Tag*",
    "banClone": "View only",
    "vipClone": "Premium",
    "freeClone": "Free to use",
    "chargeClone": "Pay to use",
    "clonePrice": "Price",
    "cancelPublish": "Cancel publication",
    "updatePublish": "Update template information",
    "readAndAgree": "I agree to the",
    "publishRules": "Template Publication Agreement",
    "publishRulesAgreeTo": "I have read and agree to the",
    "publishRulesPolicy": "Privacy Policy,",
    "publishRulesConditions": "Terms & Conditions,",
    "publishRulesAnd": "and",
    "publishRulesCommunity": "Community Guidelines.",
    "currency": {
      "unit": "dollar",
      "symbol": "$"
    },
    "validateWarn": {
      "titleRequire": "The title cannot be blank!",
      "titleFormat": "The title cannot contain any of the following characters: ",
      "desRequire": "The description cannot be blank!",
      "desLength": "The description must be at least 15 characters long!",
      "priceRequire": "The price cannot be blank!",
      "priceRange": "The price should be between $1 to $15! ",
      "tagRequire": "Please add at least one tag!",
      "agree": "Please read and tick to agree to the template release instructions"
    },
    "message": {
      "publishSuccess": "Published successfully!",
      "cancelSuccess": "Cancel publication successfully!",
      "invalidTag": "Prohibit the use of meaningless label: ",
      "toolong": "Over 20 characters!",
      "publishError": {
        "titleOver255": "The title exceeds 255 characters!",
        "titleERR_ILLEGALWORD": "Title contains illegal characters!",
        "descriptionOver255": "Description exceeds 255 characters.",
        "descriptionERR_ILLEGALWORD": "Description contains illegal characters!",
        "other": "Publish failed"
      }
    },
    "publishTips": "You can publish your file to our Template Community for users to learn and communicate. Also, you can set a price for your file to get some profits.",
    "title": "Title",
    "titlePlaceholder": "Please enter the title (less than 80 characters)",
    "description": "Description",
    "descriptionPlaceholder": "Please enter a detailed description for your file~",
    "tag": "Tag",
    "clone": "Copy",
    "cloneTips": "All users can use your file immediately",
    "payTips": "Users should pay for using your file ",
    "vipTips": "VIP of EdrawMax can use your file immediately",
    "updateOK": "The template you modified has entered the review status. We will complete the review within 7 working days. Once the review is over, it will be published in the Template Center.",
    "publishOK": "The template you posted has entered the review status. We will complete the review within 7 working days. Once the review is over, it will be published in the Template Center.",
    "preview": "Preview of your file",
    "cloneBan": "Cloned files cannot be published"
  },
  "de": {
    "alreadyPublish": "Das Dokument wird veröffentlicht. Sie können",
    "publish": "Veröffentlichen",
    "cancel": "Abbrechen",
    "titleHint": "Titel*",
    "descriptionHint": "Deskription（Die Deskription sollte mindestens 15 Zeichen lang sein）*",
    "keepAdd": "Mehr Tags hinzufügen",
    "tagHint": "Tag*",
    "banClone": "Nur anschauen",
    "freeClone": "Kostenlos benutzen",
    "chargeClone": "Zahlen Sie, um zu verwenden",
    "clonePrice": "Preis",
    "cancelPublish": "Publikation abbrechen",
    "updatePublish": "Vorlageninformationen aktualisieren",
    "readAndAgree": "Ich habe gelesen und stimme zu",
    "publishRules": "《Versionshinweise zu Vorlagen》",
    "publishRulesAgreeTo": "Ich stimme zu dem",
    "publishRulesPolicy": "Datenschutz-Bestimmungen",
    "publishRulesConditions": "Geschäftsbedingungen  Community-Richtlinien",
    "publishRulesAnd": "und",
    "publishRulesCommunity": "Vorlagenveröffentlichungsvereinbarung",
    "currency": {
      "unit": "Euro",
      "symbol": "€"
    },
    "validateWarn": {
      "titleRequire": "Der Titel darf nicht leer sein!",
      "titleFormat": "Der Titel darf keines der folgenden Zeichen enthalten: ",
      "desRequire": "Die Deskription darf nicht leer sein!",
      "desLength": "Die Beschreibung muss mindestens 15 Zeichen lang sein!",
      "priceRequire": "Der Preis darf nicht leer sein!",
      "priceRange": "Der Preis sollte zwischen $ 1 und $ 15 liegen! ",
      "tagRequire": "Bitte fügen Sie mindestens einen Tag hinzu!",
      "agree": "Bitte lesen und ankreuzen Sie, um den Anweisungen zur Vorlagenfreigabe zuzustimmen"
    },
    "message": {
      "publishSuccess": "Veröffentlichung erfolgreich!",
      "cancelSuccess": "Veröffentlichung erfolgreich abgebrochen!",
      "invalidTag": "Verwendung von sinnlosen Etiketten verboten: ",
      "toolong": "Mehr als 20 Bytes!",
      "publishError": {
        "titleOver255": "Titel hat 255 Zeichen überschritten.",
        "titleERR_ILLEGALWORD": "Titel enthält illegale Zeichen!",
        "descriptionOver255": "Beschreibung 255 Zeichen überschritten!",
        "descriptionERR_ILLEGALWORD": "Beschreibung enthält illegale Zeichen!",
        "other": "Veröffentlichung fehlgeschlagen"
      }
    },
    "publishTips": "Sie können Ihre Datei in unserer Vorlagen-Community veröffentlichen, damit Benutzer sie lernen und kommunizieren können. Sie können auch einen Preis für Ihre Datei festlegen, um Gewinne zu erzielen.",
    "title": "Titel",
    "titlePlaceholder": "Bitte geben Sie den Titel ein (Innerhalb von 80 Zeichen)",
    "description": "Beschreibung",
    "descriptionPlaceholder": "Bitte geben Sie eine detaillierte Beschreibung für Ihre Datei ein",
    "tag": "Tag",
    "clone": "Kopie",
    "cloneTips": "Alle User können Ihre Datei kostenlos kopieren",
    "payTips": "Nach dem Bezahlen können Sie Ihre Dateien kopieren",
    "updateOK": "Die von Ihnen veröffentlichte Vorlage ist auf dem Überprüfungsstand unterwegs. Wir werden die Überprüfung innerhalb von 7 Arbeitstagen fertigen. Sobald die Überprüfung abgeschlossen ist, können Sie Ihre Vorlage im Vorlagencenter veröffentlichen.",
    "publishOK": "Die von Ihnen veröffentlichte Vorlage ist auf dem Überprüfungsstand unterwegs. Wir werden die Überprüfung innerhalb von 7 Arbeitstagen fertigen. Sobald die Überprüfung abgeschlossen ist, können Sie Ihre Vorlage im Vorlagencenter veröffentlichen.",
    "preview": "Vorschau Ihrer Datei"
  },
  "fr": {
    "alreadyPublish": "Le document est publié. Vous pouvez",
    "publish": "Publier",
    "cancel": "Annuler",
    "titleHint": "Title*",
    "descriptionHint": "Description（La description doit comporter au moins 15 caractères）*",
    "keepAdd": "Ajouter plus de tags",
    "tagHint": "Tag*",
    "banClone": "Voir seulement",
    "freeClone": "Utilisation gratuite",
    "chargeClone": "Payer pour utiliser",
    "clonePrice": "Prix",
    "cancelPublish": "Annuler la publication",
    "updatePublish": "Mettre à jour les informations du modèle",
    "readAndAgree": "J'ai lu et accepté",
    "publishRules": "\"Notes de version du modèle\"",
    "publishRulesAgreeTo": "Je suis d'accord avec le",
    "publishRulesPolicy": "Politique de confidentialité Termes et conditions",
    "publishRulesConditions": "Règles de communauté",
    "publishRulesAnd": "et",
    "publishRulesCommunity": "Contrat de publication de modèle",
    "currency": {
      "unit": "Euro",
      "symbol": "€"
    },
    "validateWarn": {
      "titleRequire": "Le titre ne peut pas être vide!",
      "titleFormat": "Le titre ne peut contenir aucun des caractères suivants: ",
      "desRequire": "La description ne peut pas être vide !",
      "desLength": "La description doit comporter au moins 15 caractères !",
      "priceRequire": "Le prix ne peut pas être vide !",
      "priceRange": "Le prix devrait être entre 1$ et 15$! ",
      "tagRequire": "Veuillez ajouter au moins un tag !",
      "agree": "Veuillez lire et cocher pour accepter les instructions de publication du modèle"
    },
    "message": {
      "publishSuccess": "Publié avec succès !",
      "cancelSuccess": "Publication annulée avec succès !",
      "invalidTag": "Interdire l'utilisation d'étiquettes sans signification: ",
      "toolong": "Plus de 20 octets!",
      "publishError": {
        "titleOver255": "Le titre dépasse 255 caractères!",
        "titleERR_ILLEGALWORD": "Le titre contient des caractères illégaux!",
        "descriptionOver255": "La description dépasse 255 caractères.",
        "descriptionERR_ILLEGALWORD": "La description contient des caractères illégaux!",
        "other": "La publication a échoué"
      }
    },
    "updateOK": "Le modèle que vous avez publié est entré dans le statut de révision. Nous terminerons l'examen dans les 7 jours ouvrables. Une fois la révision terminée, elle sera publiée dans le Centre de modèles",
    "publishOK": "Le modèle que vous avez publié est entré dans le statut de révision. Nous terminerons l'examen dans les 7 jours ouvrables. Une fois la révision terminée, elle sera publiée dans le Centre de modèles",
    "preview": "Aperçu de votre fichier"
  },
  "es": {
    "alreadyPublish": "El documento está publicado. Usted puede",
    "publish": "Publicar",
    "cancel": "Cancelar",
    "titleHint": "Título*",
    "descriptionHint": "Descripción La descripción debe tener al menos 15 caracteres de longitud） *",
    "keepAdd": "Añadir más etiquetas",
    "tagHint": "Etiqueta*",
    "banClone": "Sólo ver",
    "freeClone": "Gratis de usar",
    "chargeClone": "Pagar para usar",
    "clonePrice": "Precio",
    "cancelPublish": "Cancelar publicación",
    "updatePublish": "Actualizar información de la plantilla",
    "readAndAgree": "Estoy de acuerdo con la",
    "publishRules": "Acuerdo de publicación de plantilla",
    "publishRulesAgreeTo": "Estoy de acuerdo con",
    "publishRulesPolicy": "Política de privacidad Términos y condiciones",
    "publishRulesConditions": "Principios de la Comunidad",
    "publishRulesAnd": "y",
    "publishRulesCommunity": "Acuerdo de publicación de plantillas",
    "currency": {
      "unit": "dólar",
      "symbol": "$"
    },
    "validateWarn": {
      "titleRequire": "¡El título no puede estar en blanco!",
      "titleFormat": "El título no puede contener ninguno de los siguientes caracteres: ",
      "desRequire": "¡La descripción no puede estar en blanco!",
      "desLength": "¡La descripción debe tener al menos 15 caracteres!",
      "priceRequire": "¡El precio no puede estar en blanco!",
      "priceRange": "¡El precio debe estar entre $1 y $15!",
      "tagRequire": "¡Por favor agregue al menos una etiqueta!",
      "agree": "Lea y marque para aceptar las instrucciones de publicación de la plantilla"
    },
    "message": {
      "publishSuccess": "¡Publicado exitosamente!",
      "cancelSuccess": "¡Publicación cancelada exitosamente!",
      "invalidTag": "Prohibir el uso de etiquetas sin sentido: ",
      "toolong": "¡Supera Más de 20 caracteres!",
      "publishError": {
        "titleOver255": "¡El título supera los 255 caracteres!",
        "titleERR_ILLEGALWORD": "El título contiene caracteres ilegales!",
        "descriptionOver255": "La descripción supera los 255 caracteres.",
        "descriptionERR_ILLEGALWORD": "La descripción contiene caracteres ilegales!",
        "other": "Publicación fallida"
      }
    },
    "updateOK": "La plantilla que publicaste ha entrado en estado de revisión. Completaremos la revisión dentro de los 7 días hábiles. Una vez finalizada la revisión, se publicará en el Template Cente.",
    "publishOK": "La plantilla que publicaste ha entrado en estado de revisión. Completaremos la revisión dentro de los 7 días hábiles. Una vez finalizada la revisión, se publicará en el Template Cente.",
    "preview": "Vista previa de tu archivo"
  },
  "jp": {
    "alreadyPublish": "ドキュメントが正常に投稿されました。",
    "publish": "投稿",
    "cancel": "キャンセル",
    "titleHint": "タイトル*",
    "descriptionHint": "説明（説明は15文字以上である必要があります）*",
    "keepAdd": "タグを追加",
    "tagHint": "タグ*",
    "banClone": "表示のみ",
    "freeClone": "無料体験",
    "chargeClone": "購入",
    "clonePrice": "価格",
    "cancelPublish": "投稿をキャンセルする",
    "updatePublish": "テンプレート情報を更新する",
    "readAndAgree": "「テンプレート公開説明」",
    "publishRules": "を読み、その内容に同意する",
    "publishRulesAgreeTo": "テンプレート公開契約書",
    "publishRulesPolicy": "個人情報保護方針",
    "publishRulesConditions": "コミュニティガイドライン",
    "publishRulesAnd": "そして",
    "publishRulesCommunity": "に同意します",
    "currency": {
      "unit": "元",
      "symbol": "￥"
    },
    "validateWarn": {
      "titleRequire": "タイトルを入力してください!",
      "titleFormat": "タイトルに次の文字を含めることはできません： ",
      "desRequire": "説明を入力してください!",
      "desLength": "説明は15文字以上である必要があります!",
      "priceRequire": "価格を入力してください!",
      "priceRange": "価格は$1～$15までにしてください! ",
      "tagRequire": "最低1つのタグを追加してください!",
      "agree": "テンプレートのリリース手順に同意するには、読んでチェックマークを付けてください"
    },
    "message": {
      "publishSuccess": "公開しました!",
      "cancelSuccess": "取り消しました!",
      "invalidTag": "意味のないラベルの使用を禁止する: ",
      "toolong": "20文字を超えました。",
      "publishError": {
        "titleOver255": "タイトルの文字数が上限値（255文字）を超えています。",
        "titleERR_ILLEGALWORD": "このタイトルはセンシティブな内容が含まれています",
        "descriptionOver255": "説明が上限（255文字）を超えています。",
        "descriptionERR_ILLEGALWORD": "この説明はセンシティブな内容が含まれています",
        "other": "投稿に失敗しました"
      }
    },
    "publishTips": "テンプレートを無料でコミュニティに投稿して学習・共有することもできますし、価格を設定して公開することもできます。",
    "title": "タイトル",
    "titlePlaceholder": "タイトルを80文字以内に入力してください。",
    "description": "説明",
    "descriptionPlaceholder": "詳しく記入してください。",
    "tag": "タグ",
    "clone": "クローン",
    "cloneTips": "無料でクローン",
    "payTips": "有料でクローン",
    "updateOK": "ご投稿いただいたテンプレートがレビュー状態になっており、7営業日以内に完了させます。レビューが終了すると、テンプレートセンターに掲載されます。",
    "publishOK": "ご投稿いただいたテンプレートがレビュー状態になっており、7営業日以内に完了させます。レビューが終了すると、テンプレートセンターに掲載されます。",
    "preview": "ファイルのプレビュー"
  },
  "pt": {
    "alreadyPublish": "O documento está publicado. Você pode",
    "publish": "Publicar",
    "cancel": "Cancelar",
    "titleHint": "Título*",
    "descriptionHint": "Descrição （A descrição deve ter pelo menos 15 caracteres）*",
    "keepAdd": "Adicionar mais tags",
    "tagHint": "Tag*",
    "banClone": "Apenas ver",
    "freeClone": "Livre para usar",
    "chargeClone": "Pagar para usar",
    "clonePrice": "Preço",
    "cancelPublish": "Cancelar publicação",
    "updatePublish": "Atualizar informações do modelo",
    "readAndAgree": "Concordo com o",
    "publishRules": "《Contrato de publicação de modelo》",
    "publishRulesAgreeTo": "eu concordo com o",
    "publishRulesPolicy": "Política de Privacidade termos e Condições",
    "publishRulesConditions": "Diretrizes da comunidade",
    "publishRulesAnd": "e",
    "publishRulesCommunity": "Contrato de publicação de modelo",
    "currency": {
      "unit": "yuan",
      "symbol": "￥"
    },
    "validateWarn": {
      "titleRequire": "O título não pode ficar em branco!",
      "titleFormat": "O título não pode conter nenhum dos seguintes caracteres:",
      "desRequire": "A descrição não pode ficar em branco!",
      "desLength": "A descrição deve ter pelo menos 15 caracteres!",
      "priceRequire": "O preço não pode ficar em branco!",
      "priceRange": "O preço deve ser entre ￥ 1 a ￥ 15!",
      "tagRequire": "Adicionar pelo menos uma tag!",
      "agree": "Leia e marque para concordar com as instruções de lançamento do modelo"
    },
    "message": {
      "publishSuccess": "Publicado com sucesso!",
      "cancelSuccess": "Publicação cancelada com sucesso!",
      "invalidTag": "Proibir o uso de rótulo sem sentido:",
      "toolong": "Mais de 20 bytes!",
      "publishError": {
        "titleOver255": "O título tem mais de 255 caracteres!",
        "titleERR_ILLEGALWORD": "O título contém caracteres ilegais!",
        "descriptionOver255": "A descrição excede 255 caracteres.",
        "descriptionERR_ILLEGALWORD": "A descrição contém caracteres ilegais!",
        "other": "Falha a publicação "
      }
    },
    "updateOK": "O modelo que você postou inseriu estado da revisão. Completaremos a revisão dentro de 7 dias úteis. Uma vez terminada a revisão, ela será publicada no Centro de Modelos.",
    "publishOK": "O modelo que você postou inseriu estado da revisão. Completaremos a revisão dentro de 7 dias úteis. Uma vez terminada a revisão, ela será publicada no Centro de Modelos.",
    "preview": "Pré-visualização do seu arquivo"
  },
  "it": {
    "alreadyPublish": "Il file è pubblicato, Puoi",
    "publish": "Pubblicare",
    "cancel": "Annulla",
    "titleHint": "Titolo*",
    "descriptionHint": "Descrizione (15 caratteri almeno）*",
    "keepAdd": "Continua ad aggiungere tag",
    "tagHint": "Tag*",
    "banClone": "Visualizzare solamente",
    "freeClone": "Usare Gratis",
    "chargeClone": "Pagare per l'uso",
    "clonePrice": "Prezzo",
    "cancelPublish": "Annulla pubblicazione",
    "updatePublish": "Aggiorna le informazioni sul modello",
    "readAndAgree": "Ho letto e accetto",
    "publishRules": "Regola di pubblicazione del modello",
    "publishRulesAgreeTo": "sono d'accordo con",
    "publishRulesPolicy": "politica sulla riservatezza Termini & Condizioni",
    "publishRulesConditions": "Linee guida della community",
    "publishRulesAnd": "e",
    "publishRulesCommunity": "Contratto di pubblicazione del modello",
    "currency": {
      "unit": "Euro",
      "symbol": "€"
    },
    "validateWarn": {
      "titleRequire": "Il titolo non può essere vuoto！",
      "titleFormat": "Il titolo non può contenere nessuno dei seguenti caratteri: ",
      "desRequire": "La descrizione non può essere vuota！",
      "desLength": "La descrizione deve contenere almeno 15 caratteri！",
      "priceRequire": "Il prezzo non può essere vuoto！",
      "priceRange": "Il prezzo dovrebbe essere compreso tra $1 e $15！",
      "tagRequire": "Aggiungi almeno un tag！",
      "agree": "Leggere e spuntare per accettare le istruzioni di rilascio del modello"
    },
    "message": {
      "publishSuccess": "Pubblicato con successo!",
      "cancelSuccess": "Pubblicazione annullata con successo！",
      "invalidTag": "Etichetta non valida！",
      "toolong": "Supera più di 20 caratteri！",
      "publishError": {
        "titleOver255": "Il titolo supera i 255 caratteri",
        "titleERR_ILLEGALWORD": "Il titolo contiene caratteri illegali",
        "descriptionOver255": "La descrizione supera i 255 caratteri.",
        "descriptionERR_ILLEGALWORD": "La descrizione contiene caratteri illegali",
        "other": "La pubblicazione non riuscita"
      }
    },
    "updateOK": "Il modello che hai pubblicato è entrato nello stato di revisione. Completeremo la revisione entro 7 giorni lavorativi. Una volta terminata la revisione, verrà pubblicata nel Centro modelli",
    "publishOK": "Il modello che hai pubblicato è entrato nello stato di revisione. Completeremo la revisione entro 7 giorni lavorativi. Una volta terminata la revisione, verrà pubblicata nel Centro modelli",
    "preview": "Anteprima del tuo file"
  },
  "tw": {
    "alreadyPublish": "檔案已發佈，您可以",
    "publish": "發佈",
    "cancel": "取消",
    "titleHint": "標題*",
    "descriptionHint": "描述（15個字符以上）*",
    "keepAdd": "繼續添加標籤",
    "tagHint": "標籤，按回車添加新標籤*",
    "banClone": "禁止克隆",
    "freeClone": "免費克隆",
    "chargeClone": "付費克隆",
    "clonePrice": "克隆價格",
    "cancelPublish": "取消發佈",
    "updatePublish": "更新發佈信息",
    "readAndAgree": "我已閱讀並同意",
    "publishRules": "《模板發佈須知》",
    "publishRulesAgreeTo": "我已閱讀並接受",
    "publishRulesPolicy": "隱私政策，",
    "publishRulesConditions": "服務條款，",
    "publishRulesAnd": " 和 ",
    "publishRulesCommunity": "社區公約。",
    "currency": {
      "unit": "元",
      "symbol": "￥"
    },
    "validateWarn": {
      "titleRequire": "標題不能為空！",
      "titleFormat": "標題不能包含以下字符： ",
      "desRequire": "描述不能為空！",
      "desLength": "描述不能少於15個字符！",
      "priceRequire": "價格不能為空！",
      "priceRange": "價格需要在1-10元之間！",
      "tagRequire": "請至少添加一個標籤！",
      "agree": "請閱讀並勾選同意模板發佈須知"
    },
    "message": {
      "publishSuccess": "發佈成功！",
      "cancelSuccess": "取消發佈成功！",
      "invalidTag": "該標籤不可用！",
      "toolong": "超過20字節！",
      "publishError": {
        "titleOver255": "標題超過255個字符",
        "titleERR_ILLEGALWORD": "標題中存在敏感詞",
        "descriptionOver255": "描述超過255個字符",
        "descriptionERR_ILLEGALWORD": "描述中存在敏感詞",
        "other": "發佈失敗"
      }
    },
    "publishTips": "您可以選擇您所繪製的作品發表至模板社區，供用戶學習交流，並可以設置價格，從而獲取一定的報酬。",
    "title": "標題",
    "titlePlaceholder": "請輸入心智圖標題（80个字元以內）",
    "description": "描述",
    "descriptionPlaceholder": "充分的描述更容易讓模板審核通過哦~",
    "tag": "標籤",
    "clone": "克隆",
    "cloneTips": "所有用戶都可以免費克隆您的檔案",
    "payTips": "用戶付費後可以克隆您的檔案",
    "updateOK": "您修改的作品已進入審核狀態，我們會在7個工作日內完成審核，一旦審核結束，將在模板社區公開。",
    "publishOK": "您發表的作品已進入審核狀態，我們會在7個工作日內完成審核，一旦審核結束，將在模板社區公開。",
    "preview": "檔案預覽"
  },
  "kr": {
    "alreadyPublish": "파일이 발표되었습니다. 할 수 있습니다.",
    "publish": "발표",
    "cancel": "취소",
    "titleHint": "제목*",
    "descriptionHint": "설명 「설명 길이는 15자 이상이어야 합니다.」*",
    "keepAdd": "태그 추가",
    "tagHint": "태그*",
    "banClone": "보기만",
    "freeClone": "무료 사용",
    "chargeClone": "유료 사용",
    "clonePrice": "가격",
    "cancelPublish": "발표 취소",
    "updatePublish": "템플릿 정보 업데이트",
    "readAndAgree": "본인은 다음 내용을 읽고 동의합니다.",
    "publishRules": "템플릿 발표 계약",
    "publishRulesAgreeTo": "을 읽었으며 이에 동의합니다.",
    "publishRulesPolicy": "개인정보 보호정책,",
    "publishRulesConditions": "이용약관,",
    "publishRulesAnd": "및",
    "publishRulesCommunity": "커뮤니티 가이드라인",
    "currency": {
      "unit": "원",
      "symbol": "₩"
    },
    "validateWarn": {
      "titleRequire": "제목은 비워둘 수 없습니다!",
      "titleFormat": "제목에는 다음 문자를 사용할 수 없습니다.",
      "desRequire": "설명은 비워 둘 수 없습니다!",
      "desLength": "설명은 15자 이상이어야 합니다!",
      "priceRequire": "가격은 비워둘 수 없습니다!",
      "priceRange": "가격은 1원 에서 2만원 사이여야 합니다.",
      "tagRequire": "태그를 하나 이상 추가하세요!",
      "agree": "템플릿 릴리스 지침을 읽고 체크 표시를 하여 동의하세요."
    },
    "message": {
      "publishSuccess": "발표 성공!",
      "cancelSuccess": "발표 취소 성공！",
      "invalidTag": "의미 없는 레이블 사용 금지",
      "toolong": "20문자를 초과합니다!",
      "publishError": {
        "titleOver255": "제목이 255문자를 초과합니다!",
        "titleERR_ILLEGALWORD": "제목에 잘못된 문자가 있습니다!",
        "descriptionOver255": "설명이 255문자를 초과합니다.",
        "descriptionERR_ILLEGALWORD": "설명에 잘못된 문자가 있습니다!",
        "other": "발표 실패"
      }
    },
    "publishTips": "사용자가 배우고 소통할 수 있도록 파일을 템플릿 커뮤니티에 발표할 수 있습니다. 또한 파일에 대한 가격을 설정하여 수익을 얻을 수 있습니다.",
    "title": "제목",
    "titlePlaceholder": "제목(80문자 이내)을 입력하세요.",
    "description": "설명",
    "descriptionPlaceholder": "파일에 대한 자세한 설명을 입력하세요~",
    "tag": "태그",
    "clone": "복사",
    "cloneTips": "모든 사용자가 파일을 무료로 사용할 수 있습니다.",
    "payTips": "사용자가 비용을 지불하면 파일을 복제할 수 있습니다.",
    "updateOK": "수정한 템플릿이 검토 상태가 되었습니다. 우리는 영업일 기준 7일 이내에 검토를 완료할 것입니다. 검토가 끝나면 템플릿 센터에 발표됩니다.",
    "publishOK": "발표한 템플릿이 검토 상태가 되었습니다. 우리는 영업일 기준 7일 이내에 검토를 완료할 것입니다. 검토가 끝나면 템플릿 센터에 게시됩니다.",
    "preview": "파일 미리 보기"
  }
}
</i18n>
